import { useState } from 'react';
import { S } from '@/shared/constants/styles';

const TABS = [
  { key: 'summary', label: 'Summary' },
  { key: 'alerts', label: 'Alerts' },
  { key: 'trends', label: 'Trends' },
  { key: 'forecasts', label: 'Forecasts' },
];

const EMPTY_MESSAGES = {
  summary: 'No insights yet.',
  alerts: 'No alerts this month.',
  trends: 'Not enough data yet.',
  forecasts: 'No forecast data.',
};

export default function InsightsPanel({ insightGroups, theme }) {
  const t = theme || {};
  const [activeTab, setActiveTab] = useState('summary');

  const { summary = [], alerts = [], trends = [], forecasts = [] } = insightGroups || {};
  if (!summary.length && !alerts.length && !trends.length && !forecasts.length) return null;

  const groups = { summary, alerts, trends, forecasts };
  const items = groups[activeTab] || [];

  return (
    <div style={{ ...S.card, padding: 22, marginBottom: 28, background: t.cardBg, borderColor: t.cardBorder }}>
      <div style={S.sectionTitle}>Insights</div>
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 14 }}>
        {TABS.map(tab => {
          const count = groups[tab.key]?.length || 0;
          const isActive = activeTab === tab.key;
          const label = tab.key !== 'summary' && count > 0
            ? tab.label + ' (' + count + ')'
            : tab.label;
          return (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              style={{
                background: isActive ? t.cardBorder : 'transparent',
                borderRadius: 20,
                padding: '4px 12px',
                fontSize: 12,
                fontWeight: isActive ? 600 : 400,
                color: isActive ? t.text : t.textMuted,
                border: 'none',
                cursor: 'pointer',
              }}
            >
              {label}
            </button>
          );
        })}
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {items.length === 0 ? (
          <div style={{ fontSize: 13, color: t.textMuted, padding: '8px 0' }}>
            {EMPTY_MESSAGES[activeTab]}
          </div>
        ) : items.map((ins, i) => (
          <div
            key={i}
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: 12,
              padding: '10px 14px',
              background: t.tableBg || '#f8fafc',
              borderRadius: 10,
              borderLeft: '3px solid ' + ins.color,
            }}
          >
            <span style={{ fontSize: 18, lineHeight: 1, flexShrink: 0, marginTop: 1 }}>{ins.icon}</span>
            <span style={{ fontSize: 13, color: t.text || '#334155', lineHeight: 1.5 }}>{ins.text}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
